import { useBack, useBackMultipart } from "../http";
import { RiskAssessmentHistoryDTO, RiskCompanyDTO, RiskDraftDTO, RiskDraftSavedDTO, RiskEpiDeliveryDTO, RiskFinishDTO, RiskHistoryChangesDTO, RiskLinkTreeDTO,
	RiskPanelDTO, RiskPanelEventDTO, RiskSectorDTO, RiskSheetDTO, RiskUserDTO } from "../types/RiskAssessmentDTO";

export class RiskAssessmentService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async getCompanies() {
		try {
			const response = await this.axiosInstance.get<RiskCompanyDTO[]>('/risk-assessments/companies');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as empresas do módulo de avaliação de riscos`, error);
			return undefined;
		}
	}

	async getEpiDeliveries(companyId: number, months: number | null) {
		try {
			const response = await this.axiosInstance
				.get<RiskEpiDeliveryDTO[]>(`/risk-assessments/companies/${companyId}/epi-deliveries`,
					{ params: months === null ? undefined : { months } });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as entregas de EPI da empresa`, error);
			return undefined;
		}
	}

	async getCompanyStructure(companyId: number) {
		try {
			const response = await this.axiosInstance
				.get<RiskSectorDTO[]>(`/risk-assessments/companies/${companyId}/structure`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os setores e cargos da empresa`, error);
			return undefined;
		}
	}

	async parse(form: FormData) {
		const response = await this.axiosInstanceMultipart.post<RiskSheetDTO>('/risk-assessments/parse', form);
		return { ...response };
	}

	async createDraft(form: FormData) {
		const response = await this.axiosInstanceMultipart.post<{ id: number }>('/risk-assessments/drafts', form);
		return { ...response };
	}

	async getDraft(id: string) {
		const response = await this.axiosInstance.get<RiskDraftDTO>(`/risk-assessments/drafts/${id}`);
		return { ...response };
	}

	async saveDraft(id: string, version: number, state: string) {
		const response = await this.axiosInstance
			.put<RiskDraftSavedDTO>(`/risk-assessments/drafts/${id}/state`, { version, state });
		return { ...response };
	}

	async finishDraft(id: string, data: RiskFinishDTO) {
		const response = await this.axiosInstance
			.post<Blob>(`/risk-assessments/drafts/${id}/finish`, data, { responseType: 'blob' });
		return { ...response };
	}

	async assignDraft(id: number, username: string, stage: string) {
		const response = await this.axiosInstance
			.put<RiskAssessmentHistoryDTO>(`/risk-assessments/drafts/${id}/assignment`, { username, stage });
		return { ...response };
	}

	async getUsers() {
		try {
			const response = await this.axiosInstance.get<RiskUserDTO[]>('/risk-assessments/users');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os usuários internos`, error);
			return undefined;
		}
	}

	async getHistory() {
		try {
			const response = await this.axiosInstance.get<RiskAssessmentHistoryDTO[]>('/risk-assessments/history');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o histórico de avaliações de riscos`, error);
			return undefined;
		}
	}

	async getHistoryChanges(id: string) {
		const response = await this.axiosInstance.get<RiskHistoryChangesDTO>(`/risk-assessments/history/${id}/changes`);
		return { ...response };
	}

	async downloadHistoryFile(id: number) {
		try {
			const response = await this.axiosInstance
				.get<Blob>(`/risk-assessments/history/${id}/file`, { responseType: 'blob' });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível baixar a planilha da avaliação de riscos`, error);
			return undefined;
		}
	}

	async getPanel() {
		try {
			const response = await this.axiosInstance.get<RiskPanelDTO>('/risk-assessments/panel');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o painel da avaliação de riscos`, error);
			return undefined;
		}
	}

	async importEpiCatalog(form: FormData) {
		const response = await this.axiosInstanceMultipart
			.post<RiskPanelEventDTO>('/risk-assessments/epi-catalog/import', form);
		return { ...response };
	}

	async refreshLinks() {
		const response = await this.axiosInstance.post<RiskPanelEventDTO>('/risk-assessments/links/refresh');
		return { ...response };
	}

	async getLinks() {
		try {
			const response = await this.axiosInstance.get<RiskLinkTreeDTO>('/risk-assessments/links');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os vínculos de riscos`, error);
			return undefined;
		}
	}
}
